import React from 'react';
import PropTypes from 'prop-types';

import LoadingImage from '../../assets/svgs/LoadingImage';

import { LoadingProgressBarStyle } from './LoadingProgressBarStyle';

const LoadingProgressBar = ({ message, progress }) => {
  return (
    <LoadingProgressBarStyle>
      <div className="loading-message-container">
        <div className="loading-image-wrapper">
          <LoadingImage />
        </div>
        {message && message.length ? (
          <div className="loading-message-wrapper">{message}</div>
        ) : null}
        <div className="loading-progress-bar">
          <div
            className="loading-progress"
            style={{ width: `${progress}%` }}
          >
            {progress < 100 && (
              <span className="loading-progress-text">{`${progress}%`}</span>
            )}
          </div>
        </div>
      </div>
    </LoadingProgressBarStyle>
  );
};

LoadingProgressBar.propTypes = {
  message: PropTypes.string,
  progress: PropTypes.number,
};

LoadingProgressBar.defaultProps = {
  message: '',
  progress: undefined,
};

export default LoadingProgressBar;
